import { render, staticRenderFns } from "./modalOnboardingAssistance.vue?vue&type=template&id=4f3b05df&"
import script from "./modalOnboardingAssistance.vue?vue&type=script&lang=js&"
export * from "./modalOnboardingAssistance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports